import { smoothScroll } from "./utilities/smoothScroll";
import { WindowInfo } from "./utilities/WindowInfo";
import { ScrollInfo } from "./utilities/ScrollInfo";
import { visibleFocusHandler } from "./utilities/visibleFocusHandler";
import wrapTables from "./components/wrapTables.js";
import overflow from "./components/overflow.js";

import header from "./components/header";
import footer from "./components/footer";
import waypoints from "./components/waypoints";
import titleAnimations from "./components/titleAnimations";
import heroHomepage from "./components/heros/heroHomepage";
import parallax from "./components/parallax.js";
import statements from "./components/statements";
import testimonials from "./components/testimonials";
import logos from "./components/logos";
import accordions from "./components/accordions";
import share from "./components/share";
import { caseStudies } from "./components/caseStudies";
import { discover } from "./components/discover";
import { whyPartnerWithUs } from "./components/why-partner-with-us.js";

window.addEventListener("DOMContentLoaded", () => {
    // Providers
    new ScrollInfo();
    new WindowInfo();

    // Utilities
    visibleFocusHandler();
    titleAnimations();
    smoothScroll();
    waypoints();
    parallax();

    // Components
    header();
    footer();
    heroHomepage();
    statements();
    testimonials();
    logos();
    caseStudies();
    discover();
    share();
    accordions(".card-accordion");
    accordions(".card-person");
    accordions(".filter");

    whyPartnerWithUs();

    // Add overflow container wrapper to tables added into content areas, to add overflow styling on small screens
    wrapTables(document.querySelectorAll(".wysiwyg table"), "table-overflow-container", "overflow-container");
    // Add overflow functionality to elements with .overflow-container
    overflow(document.getElementsByClassName("overflow-container"));
});

// On load event, get all of the below the fold images
window.addEventListener(
    "load",
    function() {
        const videos = document.querySelectorAll("video");
        videos.forEach(video => {
            video.setAttribute("src", video.dataset.src);
            video.load();
        });

        // Only load the globe on the challenge template
        const challenge = document.body.classList.contains("page-challenges");
        if (challenge) {
            const loadDynamicScript = callback => {
                const existingScript = document.getElementById("globeJS");

                if (!existingScript) {
                    const script = document.createElement("script");
                    script.src = "dist/globe.js"; // URL for the third-party library being loaded.
                    script.id = "globeJS";
                    document.body.appendChild(script);

                    script.onload = () => {
                        if (callback) callback();
                    };
                }

                if (existingScript && callback) callback();
            };

            loadDynamicScript();
        }
    },
    {
        passive: false,
        once: true,
    }
);
